import ContactForm from "../components/ContactForm";
import hotelImg from "../assests/images/hotel-bg.jpg";
import {
  Mail,
  Phone,
  MapPin,
  ArrowUpRight,
  Clock,
  ShieldCheck,
  MessageCircle,
  Navigation,
  Sparkles,
} from "lucide-react";
import { Helmet } from "react-helmet-async";

export default function ContactUs() {
  const phone = "+971 4 447 3839";
  const email = "info@southtravels.com";
  const address =
    "Office 302, 3rd Flr. HDS Tower, Cluster F, Jumeirah Lakes Towers, Dubai";

  return (
    <>
      <Helmet>
        <title>Contact Us | Cheap Dubai Hotels</title>
        <meta
          name="description"
          content="Contact our Dubai travel team for hotel bookings, travel services, tours, visa assistance, car rentals and booking support."
        />
        <link
          rel="canonical"
          href="https://cheapdubaihotels.com/contact"
        />
        <meta property="og:title" content="Contact Us | Cheap Dubai Hotels" />
        <meta
          property="og:description"
          content="Our Dubai travel team is here to help you plan your next trip."
        />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>

      <main className="overflow-hidden bg-[#F4F8FB] text-[#062F4F]">
        {/* NEW SPLIT HERO */}
        {/* FULL-WIDTH CONTACT BANNER */}
        <section
          className="relative flex min-h-[250px] items-center justify-center overflow-hidden bg-cover bg-center px-5 py-20 sm:min-h-[220px] lg:min-h-[250px] mt-28"
          style={{ backgroundImage: `url(${hotelImg})` }}
        >
          <div className="absolute inset-0 bg-[#062F4F]/75" />

          <div className="relative z-10 mx-auto max-w-4xl text-center text-white">
            <p className="mb-4 inline-flex items-center gap-2 rounded-full border border-white/30 bg-white/10 px-5 py-2 text-sm font-semibold backdrop-blur-sm">
              <MessageCircle size={16} />
              We're here to help
            </p>

            <h1 className="text-4xl font-extrabold tracking-tight sm:text-5xl lg:text-6xl">
              Contact Us
            </h1>

            <p className="mx-auto mt-5 max-w-2xl text-base leading-8 text-white/90 sm:text-lg">
              Get in touch with our Dubai travel team for hotel bookings,
              travel enquiries, tours, and personalised assistance.
            </p>


          </div>
        </section>

        {/* QUICK CONTACT CARDS */}
        <section className="px-4 pb-14 sm:px-6 lg:px-10 lg:pb-20 mt-20">
          <div className="mx-auto  max-w-[1536px] mx-auto
              px-4
            sm:px-6
            lg:px-8">
            <div className="mb-8 flex flex-col justify-between gap-4 sm:flex-row sm:items-end">
              <div>
                <p className="mb-3 text-sm font-bold uppercase tracking-[0.18em] text-[#0B6E8E]">
                  Get in touch
                </p>
                <h2 className="text-3xl font-extrabold sm:text-4xl">
                  Choose how to reach us
                </h2>
              </div>
              <p className="max-w-md text-sm leading-7 text-slate-600 sm:text-base">
                Choose the contact option that works best for you. We're
                happy to help with your travel questions.
              </p>
            </div>

            <div className="grid gap-5 md:grid-cols-3">
              <a
                href={`tel:${phone.replace(/[^+\d]/g, "")}`}
                className="group rounded-2xl border border-slate-100 bg-white p-6 shadow-sm transition duration-300 hover:-translate-y-1 hover:shadow-xl hover:shadow-[#062F4F]/10 sm:p-8"
              >
                <div className="mb-6 flex h-14 w-14 items-center justify-center rounded-2xl bg-[#E7F4F8] text-[#0B6E8E] transition group-hover:bg-[#0B6E8E] group-hover:text-white">
                  <Phone size={25} />
                </div>
                <p className="text-sm font-semibold text-slate-500">
                  Give us a call
                </p>
                <h3 className="mt-2 text-xl font-extrabold">{phone}</h3>
                <div className="mt-5 flex items-center gap-2 text-sm font-bold text-[#0B6E8E]">
                  Call now <ArrowUpRight size={17} />
                </div>
              </a>

              <a
                href={`mailto:${email}`}
                className="group rounded-2xl border border-slate-100 bg-white p-6 shadow-sm transition duration-300 hover:-translate-y-1 hover:shadow-xl hover:shadow-[#062F4F]/10 sm:p-8"
              >
                <div className="mb-6 flex h-14 w-14 items-center justify-center rounded-2xl bg-[#FFF4DF] text-[#B77900] transition group-hover:bg-[#F7B928] group-hover:text-[#062F4F]">
                  <Mail size={25} />
                </div>
                <p className="text-sm font-semibold text-slate-500">
                  Send us an email
                </p>
                <h3 className="mt-2 break-words text-xl font-extrabold">
                  {email}
                </h3>
                <div className="mt-5 flex items-center gap-2 text-sm font-bold text-[#0B6E8E]">
                  Email us <ArrowUpRight size={17} />
                </div>
              </a>

              <a
                href="https://www.google.com/maps/search/?api=1&query=HDS+Tower+Cluster+F+Jumeirah+Lakes+Towers+Dubai"
                target="_blank"
                rel="noreferrer"
                className="group rounded-2xl border border-slate-100 bg-white p-6 shadow-sm transition duration-300 hover:-translate-y-1 hover:shadow-xl hover:shadow-[#062F4F]/10 sm:p-8"
              >
                <div className="mb-6 flex h-14 w-14 items-center justify-center rounded-2xl bg-[#FFF0E9] text-[#FF5A1F] transition group-hover:bg-[#FF5A1F] group-hover:text-white">
                  <MapPin size={25} />
                </div>
                <p className="text-sm font-semibold text-slate-500">
                  Visit our office
                </p>
                <h3 className="mt-2 text-xl font-extrabold">
                  Jumeirah Lakes Towers
                </h3>
                <div className="mt-5 flex items-center gap-2 text-sm font-bold text-[#0B6E8E]">
                  Get directions <ArrowUpRight size={17} />
                </div>
              </a>
            </div>
          </div>
        </section>

        {/* CONTACT FORM + DETAILS */}
        <section
          id="contact-form"
          className="border-y border-slate-100 bg-white px-4 py-14 sm:px-6 lg:px-10 lg:py-24"
        >
          <div className="mx-auto grid  max-w-[1536px] mx-auto
              px-4
            sm:px-6
            lg:px-8 items-start gap-10 lg:grid-cols-[minmax(0,1.25fr)_minmax(300px,0.75fr)] lg:gap-16">
            {/* Form */}
            <div className="min-w-0 rounded-3xl border border-slate-100 bg-white p-5 shadow-xl shadow-[#062F4F]/5 sm:p-8 lg:p-10">
              <div className="mb-8">
                <span className="inline-block rounded-full bg-[#E7F4F8] px-4 py-2 text-xs font-bold uppercase tracking-wider text-[#0B6E8E]">
                  Contact form
                </span>
                <h2 className="mt-5 text-3xl font-extrabold sm:text-4xl">
                  Tell us what you need
                </h2>
                <p className="mt-3 leading-7 text-slate-600">
                  Share a few details below so we can better understand your
                  enquiry.
                </p>
              </div>

              <ContactForm />
            </div>

            {/* New contact information panel */}
            <aside className="lg:sticky lg:top-8">
              <div className="rounded-3xl bg-[#062F4F] p-6 text-white sm:p-9">
                <span className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-2 text-sm font-semibold text-[#F7B928]">
                  <MessageCircle size={16} />
                  We're here to help
                </span>

                <h2 className="mt-6 text-3xl font-extrabold leading-tight !text-white">
                  A little help can make a big difference.
                </h2>

                <p className="mt-4 leading-7 text-white/70">
                  Whether you have a booking question or need help planning
                  your trip, reach out to our team.
                </p>

                <div className="my-8 h-px bg-white/15" />

                <div className="space-y-6">
                  <div className="flex items-start gap-4">
                    <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-white/10 text-[#F7B928]">
                      <Phone size={20} />
                    </div>
                    <div className="min-w-0">
                      <p className="text-sm text-white/60">Phone</p>
                      <a
                        href={`tel:${phone.replace(/[^+\d]/g, "")}`}
                        className="mt-1 block break-words font-bold transition hover:text-[#F7B928]"
                      >
                        {phone}
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-white/10 text-[#F7B928]">
                      <Mail size={20} />
                    </div>
                    <div className="min-w-0">
                      <p className="text-sm text-white/60">Email</p>
                      <a
                        href={`mailto:${email}`}
                        className="mt-1 block break-words font-bold transition hover:text-[#F7B928]"
                      >
                        {email}
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-white/10 text-[#F7B928]">
                      <MapPin size={20} />
                    </div>
                    <div className="min-w-0">
                      <p className="text-sm text-white/60">Office address</p>
                      <p className="mt-1 leading-7">{address}</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-white/10 text-[#F7B928]">
                      <Clock size={20} />
                    </div>
                    <div>
                      <p className="text-sm text-white/60">Enquiries</p>
                      <p className="mt-1 font-semibold">
                        Send us a message anytime
                      </p>
                    </div>
                  </div>
                </div>

                <a
                  href={`mailto:${email}`}
                  className="mt-9 flex w-full items-center justify-center gap-2 rounded-xl bg-[#F7B928] px-5 py-4 font-extrabold text-[#062F4F] transition hover:bg-white"
                >
                  Email our team
                  <ArrowUpRight size={18} />
                </a>
              </div>

              <div className="mt-5 flex items-start gap-3 rounded-2xl border border-[#DCECF2] bg-[#F1F9FC] p-5">
                <ShieldCheck
                  size={23}
                  className="mt-0.5 shrink-0 text-[#0B6E8E]"
                />
                <p className="text-sm leading-6 text-slate-600">
                  <span className="font-bold text-[#062F4F]">
                    Need booking assistance?
                  </span>{" "}
                  Include your booking details in your message if you need
                  help with an existing reservation.
                </p>
              </div>
            </aside>
          </div>
        </section>

        {/* REDESIGNED OFFICE / MAP SECTION */}
        <section className="px-4 py-14 sm:px-6 lg:px-10 lg:py-24">
          <div className="mx-auto  max-w-[1536px] mx-auto
              px-4
            sm:px-6
            lg:px-8">
            <div className="mb-9 max-w-2xl">
              <p className="mb-3 text-sm font-bold uppercase tracking-[0.18em] text-[#0B6E8E]">
                Find us in Dubai
              </p>
              <h2 className="text-3xl font-extrabold sm:text-4xl">
                Our office location
              </h2>
              <p className="mt-4 leading-7 text-slate-600">
                Find our office in Jumeirah Lakes Towers. Use the map below
                to plan your visit.
              </p>
            </div>

            <div className="grid overflow-hidden rounded-3xl bg-white shadow-xl shadow-[#062F4F]/10 lg:grid-cols-[minmax(0,1.5fr)_minmax(300px,0.7fr)]">
              <div className="min-h-[320px] bg-slate-200 sm:min-h-[420px]">
                <iframe
                  title="Office location in Jumeirah Lakes Towers, Dubai"
                  src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d3613.775341638421!2d55.143142861862316!3d25.0756025365207!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1sOffice%20302%2C%203rd%20Flr.%20HDS%20Tower%20Cluster%20F%2C%20Jumeirah%20Lakes%20Towers%20Dubai!5e0!3m2!1sen!2sae!4v1789480084690!5m2!1sen!2sae"
                  width="100%"
                  height="100%"
                  style={{ border: 0, minHeight: "320px" }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="strict-origin-when-cross-origin"
                />
              </div>

              <div className="flex flex-col justify-center p-7 sm:p-10 lg:p-12">
                <div className="mb-6 flex h-14 w-14 items-center justify-center rounded-2xl bg-[#FFF0E9] text-[#FF5A1F]">
                  <MapPin size={27} />
                </div>

                <p className="text-sm font-bold uppercase tracking-wider text-[#0B6E8E]">
                  Our address
                </p>

                <h3 className="mt-3 text-2xl font-extrabold leading-snug">
                  HDS Tower, Cluster F
                </h3>

                <p className="mt-4 leading-7 text-slate-600">
                  Office 302, 3rd Floor,
                  <br />
                  HDS Tower, Cluster F,
                  <br />
                  Jumeirah Lakes Towers, Dubai, UAE
                </p>

                <a
                  href="https://www.google.com/maps/search/?api=1&query=HDS+Tower+Cluster+F+Jumeirah+Lakes+Towers+Dubai"
                  target="_blank"
                  rel="noreferrer"
                  className="mt-8 inline-flex w-fit items-center gap-2 rounded-xl bg-[#0B6E8E] px-5 py-4 font-bold text-white transition hover:bg-[#062F4F]"
                >
                  <Navigation size={18} />
                  Open in Google Maps
                  <ArrowUpRight size={17} />
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* BOTTOM CALL TO ACTION */}
        <section className="pb-14 lg:pb-20  mx-auto  max-w-[1536px]
              px-4
            sm:px-6
            lg:px-8">
          <div className="relative overflow-hidden rounded-3xl bg-[#0B6E8E] px-6 py-10 text-white sm:px-10 sm:py-12 lg:px-14">
            <div className="pointer-events-none absolute -right-10 -top-20 h-64 w-64 rounded-full border-[35px] border-white/10" />
            <div className="pointer-events-none absolute -bottom-24 right-40 h-48 w-48 rounded-full bg-[#F7B928]/20 blur-2xl" />

            <div className="relative flex flex-col justify-between gap-7 md:flex-row md:items-center">
              <div className="max-w-2xl">
                <p className="mb-3 text-sm font-bold uppercase tracking-[0.18em] text-[#F7B928]">
                  Let's plan your next trip
                </p>
                <h2 className="text-3xl font-extrabold leading-tight sm:text-4xl !text-white">
                  Have a question? We're just a message away.
                </h2>
                <p className="mt-3 leading-7 text-white/80">
                  Contact our team and let us help you with your travel
                  enquiry.
                </p>
              </div>

              <a
                href="#contact-form"
                className="inline-flex shrink-0 items-center justify-center gap-2 rounded-xl bg-white px-6 py-4 font-extrabold text-[#062F4F] transition hover:-translate-y-0.5 hover:bg-[#F7B928]"
              >
                Contact us
                <ArrowUpRight size={19} />
              </a>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}